export const selectSettings = state => state.settings;
